import { render, staticRenderFns } from "./DagelijkseSoepBase.vue?vue&type=template&id=02741068&"
import script from "./DagelijkseSoepBase.vue?vue&type=script&lang=js&"
export * from "./DagelijkseSoepBase.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports